import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControlName][appPercentageMask]',
})
export class PercentageMaskDirective {
  constructor(public ngControl: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onInputChange(value: string): void {
    let numericValue = value.replace(/[^\d.]/g, ''); // Remove non-numeric characters.
    numericValue = numericValue.replace(/^0+/, ''); // Remove leading zeros.
    if (numericValue && !isNaN(Number(numericValue))) {
      this.ngControl.control.setValue(numericValue + '%', { emitEvent: false });
    } else {
      this.ngControl.control.setValue('', { emitEvent: false });
    }
  }
}
